import React from "react";
import styles from "./subscriptionExpiredModal.module.css";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useTranslation } from "react-i18next";

export const SubscriptionExpiredModal = ({ expireDate, onClose }) => {
  const { t } = useTranslation("login");

  // Format date to YYYY-MM-DD
  const formattedDate = React.useMemo(() => {
    if (!expireDate) return "";
    try {
      const d = new Date(expireDate);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    } catch (e) {
      return expireDate.split("T")[0] || expireDate;
    }
  }, [expireDate]);

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.iconWrap}>
          <WarningAmberRoundedIcon className={styles.warningIcon} />
        </div>
        <h2 className={styles.title}>{t("Account Expired")}</h2>
        <div className={styles.textContainer}>
          <p className={styles.paragraph}>
            {/* {t("Your enterprise license expired on")} <strong className={styles.dateText}>{formattedDate}</strong>. */}
              {t("Your enterprise license expired on {{date}}.", { date: formattedDate })}
          </p>
          <p className={styles.paragraph}>
            {t("Please contact your Evercomm sales representative to renew your subscription and continue using the NXMap service.")}
          </p>
        </div>
        <button className={styles.confirmBtn} onClick={onClose}>
          {t("Confirm")}
        </button>
      </div>
    </div>
  );
};
